import { html } from 'lit';
import { virtual } from 'haunted';
import { breakpoints } from '../_lib/breakpoints.js';
import { isEventClick, isKeyEnterOrKeySpace } from '@outbook/a11y';

export const PrefWidth = virtual(
  ({ viewportWidth, setViewportWidth, literals }) => {
    function handleSize(size) {
      return ev => {
        if (isEventClick(ev) || isKeyEnterOrKeySpace(ev)) {
          setViewportWidth(size);
        }
      };
    }

    const selectedSize = breakpoints.find(item => {
      return item.max === viewportWidth;
    }).width;

    return html`
      <div class="flex flex-col items-center">
        <p class="text-gray-900 dark:text-gray-100 mb-2">
          ${literals.width}: ${selectedSize}
        </p>
        <ul class="w-full max-w-bk-6 relative h-8 overflow-hidden">
          ${breakpoints.map(item => {
            const isSelected = viewportWidth === item.max;
            return html`
              <li
                class="${item.classes} absolute top-0 left-1/2 transform -translate-x-1/2"
              >
                <div
                  class="w-full flex justify-between ${
                    isSelected ? 'h-8' : 'h-6'
                  }"
                  role="button"
                  tabindex="0"
                  aria-pressed="${String(isSelected)}"
                  @click="${handleSize(item.max)}"
                  @keydown="${handleSize(item.max)}"
                >
                  <div class="text-s pl-3 ${isSelected ? 'font-bold' : ''}">
                    ${item.width}
                  </div>
                  <div
                    class="text-s pr-3 ${isSelected ? 'font-bold' : ''}"
                    aria-hidden="true"
                  >
                    ${item.width}
                  </div>
                </div>
              </li>
            `;
          })}
        </ul>
      </div>
    `;
  }
);
